module.exports = __webpack_public_path__ + "img/BE5F5F_F4BDBD_ECA4A4_E29191-256px.bd6dda95.png";